<template>
  <div class="day" :class="{due: due, 'due-soon': isDueSoon, 'is-today': isToday}">
    <div class="day-of-week">{{ dayOfWeek }}</div>
    <div class="date">
      <div class="month">{{ month}}</div>
      <div class="number">{{ this.day.getDate() }}</div>
    </div>
    <div class="today-label" v-if="isToday && !due">Today</div>
    <div class="due-label" v-if="due">Due</div>
  </div>
</template>

<script>
export default {
  name: "Day",
  props: ["day", "due", "dueDate"],
  computed: {
    isToday() {
      return this.day.getDate() === new Date().getDate();
    },
    isDue() {
      console.log(
        "isDue",
        this.day,
        this.dueDate,
        this.formatDate(this.day),
        this.formatDate(this.dueDate)
      );
    },
    isDueSoon() {
      if (!this.due) {
        return false;
      }

      const now = new Date();
      const diff = this.day.getTime() - now.getTime();

      return diff < 129600000;
    },
    dayOfWeek() {
      var days = ["Sun", "Mon", "Tue", "Wed", "Thurs", "Fri", "Sat"];

      return days[this.day.getDay()];
    },
    month() {
      var months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "June",
        "July",
        "Aug",
        "Sept",
        "Oct",
        "Nov",
        "Dec"
      ];
      return months[this.day.getMonth()];
    }
  },
  methods: {
    formatDate(date) {
      const options = { year: "numeric", month: "long", day: "numeric" };
      return date.toLocaleDateString("en-US", options);
    }
  }
};
</script>

<style lang="scss" scoped>
.day {
  flex-basis: 70px;
  margin: 16px;
  font-family: $font-family;
}

.due {
  .date {
    background: lighten(#43a047, 2%);
    border: 0px solid lighten(#c8e6c9, 2%);
    box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.25);
    color: #fff;
  }
  .month {
    padding-top: 5px;
    color: #fff;
  }
  .number {
    font-weight: 700;
    color: #fff;
  }
}
.due-soon {
  .date {
    background: lighten(#ef6c00, 2%) !important;
    border: 0px solid lighten(#c8e6c9, 2%);
    box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.25);
    color: #fff;
  }
}

.is-today {
  .date {
    // border: 3px solid darken(#daedff, 22%);
  }
}

.day-of-week {
  padding-bottom: 4px;
  text-align: center;
  font-size: 12pt;
  font-weight: 500;
}

.due-label,
.today-label {
  padding-bottom: 4px;
  text-align: center;
  font-size: 12pt;
  font-weight: 700;
  color: #4caf50;
}
.today-label {
  color: $color-blue;
}
.due-soon .due-label {
  color: #ef6c00 !important;
}

.date {
  border: 3px solid #eee;
  border-radius: 8px;
  width: 70px;
  height: 70px;
}

.month {
  padding-top: 2px;
  text-align: center;
  font-size: 11pt;
  font-weight: 500;
}

.number {
  line-height: 26px;
  text-align: center;
  font-size: 17pt;
  font-weight: 500;
}

@media (max-width: 1024px) {
  .day {
    margin: 12px 7px;
    flex-basis: 62px !important;
  }
  .day:first-child {
    margin-left: 4px !important;
  }

  .date {
    border: 3px solid #eee;
    border-radius: 8px;
    width: 62px;
    height: 62px;
  }
}
</style>


